import { fromJS } from 'immutable'
import {
  TIMESHEET_GET_PROJECTS_REQUEST,
  TIMESHEET_GET_PROJECTS_SUCCESS,
  TIMESHEET_GET_PROJECTS_FAILURE,
  TIMESHEET_GET_PROJECTS_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_GET_PROJECTS_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_GET_PROJECTS_SUCCESS:
      return state
        .set('timesheets', fromJS(action.payload))
        .set('isFetching', false)
    case TIMESHEET_GET_PROJECTS_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case TIMESHEET_GET_PROJECTS_RESET:
      return state
        .delete('timesheets')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-get-projects-reducer.js